// Parse a Handsontable cell value to a number, stripping the thousands separators / currency chars the
// grid formats large (>= 1000) values with ("1,155", "$ 8,874") — plain Number() returns NaN on those,
// which blanks a large price on render or misreads it in a comparison. Drop-in for Number(cellValue):
// numbers pass through; strings are stripped then parsed; anything else uses Number()'s own semantics.
//
// Lives in its own leaf module (rather than in SmartBaselineBenchmarkRenderer) so shared consumers like
// UserProvidedBaselineCell can import it without creating an import cycle.
export const parseCellNumber = (v: unknown): number =>
  (typeof v === 'number' ? v : Number(typeof v === 'string' ? v.replace(/[^\d.-]/g, '') : v));
